module.exports = __webpack_public_path__ + "img/INTERIOR-BALENO-5.d2526e80.jpg";